<script>
  import { highlightWords, getSearchTerm, debounce } from './search.js';
  import { i18n } from '@/commons/utils';
  import { onMount } from 'svelte';
  import { fly, fade } from 'svelte/transition';


  // VARS
  export let params = {};
  export let trends = [];

  const searchlocaleurl = params.searchlocaleurl || '/search';

  let input;
  let searchTerm = params.value || '';
  let searchResults = null;
  let showResultPanel = false;
  let minSearchLength = parseInt(params.minLength, 10) || 3;
  let maxSearchLength = parseInt(params.maxLength, 10) || 255;
  let lastSearchterm = '';

  $: showResults = isValid() && showResultPanel && searchResults;
  $: showTrends = searchTerm.length === 0 && showResultPanel && trends && trends.length;


  onMount(() => input.value = searchTerm);

  // METHODS
  const close = event => {
    if (event &&
      // User press Escape
      (event.type === 'keydown' && event.keyCode === 27) ||
      // User click outside the searchbar
      (event.type === 'click' && !event.target.closest('.l-search-form'))
    ) {
      showResultPanel = false;
    }
  };

  const isValid = () => searchTerm.length >= minSearchLength && searchTerm.length <= maxSearchLength;

  const search = debounce(() => {
    searchTerm = input.value;
    if (isValid() && lastSearchterm !== searchTerm) {
      lastSearchterm = searchTerm;
      getSearchTerm(searchTerm, params)
        .then(response => {
          const pages = response.pages && response.pages.length ? response.pages : null;
          const products = response.productsList && response.productsList.length ? response.productsList : null;

          searchResults = (pages || products) ? { pages, products } : null;
          showResultPanel = true;
        })
        .catch(error => {
          showResultPanel = false;
          searchResults = null;
        });
      ;
    };
  }, 500);


  const submit = event => {
    if (!isValid()) event.preventDefault();
  };
</script>


<style type="less">/*     Links     */
/*     Main colors     */
/*     Forms     */
/* tiny font sizes (mobile first) */
/* font-weights */
/* font-weights china limits */
/* Path */
/* Font families */
/* Default font stacks */
/* Chinese font stacks */
/* Breakpoints */
/* === ============= === */
/* VARS */
/*== Colors
//
//## Gray and brand colors for use across Bootstrap. */
/*== Scaffolding
//
//## Settings for some of the most global styles. */
/* Background color for `<body>`. */
/* Global text color on `<body>`. */
/* Global textual link color. */
/* Link hover color set via `darken()` function. */
/* Link hover decoration.alert */
/*== Typography
//
//## Font, line-height, and color for body text, headings, and more. */
/* Default monospace fonts for `<code>`, `<kbd>`, and `<pre>`. */
/* Unit-less `line-height` for use in components like buttons. */
/* Computed "line-height" (`font-size` * `line-height`) for use with `margin`, `padding`, etc. */
/* By default, this inherits from the `<body>`. */
/*== Iconography
//
//## Specify custom location and filename of the included Glyphicons icon font. Useful for those including Bootstrap via Bower. */
/* Load fonts from this directory. */
/* File name for all font files. */
/* Element ID within SVG icon file. */
/*== Components
//
//## Define common padding and border radius sizes and more. Values based on 14px text and 1.428 line-height (~20px to start). */
/* Global color for active items (e.g., navs or dropdowns). */
/* Global background color for active items (e.g., navs or dropdowns). */
/* Width of the `border` for generating carets that indicator dropdowns. */
/* Carets increase slightly in size for larger components. */
/*== Tables
//
//## Customizes the `.table` component with basic values, each used across all table variations. */
/* Padding for `<th>`s and `<td>`s. */
/* Padding for cells in `.table-condensed`. */
/* Default background color used for all tables. */
/* Background color used for `.table-striped`. */
/* Background color used for `.table-hover`. */
/* Border color for table and cell borders. */
/*== Buttons
//
//## For each of Bootstrap's buttons, define text, background and border color. */
/* Allows for customizing button radius independently from global border radius */
/*== Forms
//
//## */
/* `<input>` background color */
/* `<input disabled>` background color */
/* Text color for `<input>`s */
/* `<input>` border color */
/* TODO: Rename `@input-border-radius` to `@input-border-radius-base` in v4 */
/* Default `.form-control` border radius */
/* This has no effect on `<select>`s in some browsers, due to the limited stylability of `<select>`s in CSS. */
/* Large `.form-control` border radius */
/* Small `.form-control` border radius */
/* Border color for inputs on focus */
/* Placeholder text color */
/* Default `.form-control` height */
/* Large `.form-control` height */
/* Small `.form-control` height */
/* `.form-group` margin */
/* Background color for textual input addons */
/* Border color for textual input addons */
/* Disabled cursor for form controls and buttons. */
/*== Dropdowns
//
//## Dropdown menu container and contents. */
/* Background for the dropdown menu. */
/* Dropdown menu `border-color`. */
/* Dropdown menu `border-color` **for IE8**. */
/* Divider color for between dropdown items. */
/* Dropdown link text color. */
/* Hover color for dropdown links. */
/* Hover background for dropdown links. */
/* Active dropdown menu item text color. */
/* Active dropdown menu item background color. */
/* Disabled dropdown menu item background color. */
/* Text color for headers within dropdown menus. */
/* Deprecated `@dropdown-caret-color` as of v3.1.0 */
/*-- Z-index master list
//
// Warning: Avoid customizing these values. They're used for a bird's eye view
// of components dependent on the z-axis and are designed to all work together.
//
// Note: These variables are not generated into the Customizer. */
/*== Media queries breakpoints
//
//## Define the breakpoints at which your layout will change, adapting to different screen sizes. */
/* Extra small screen / phone */
/* Deprecated `@screen-xs` as of v3.0.1 */
/* Deprecated `@screen-xs-min` as of v3.2.0 */
/* Deprecated `@screen-phone` as of v3.0.1 */
/* Deprecated `@screen-sm` as of v3.0.1 */
/* Deprecated `@screen-tablet` as of v3.0.1 */
/* Deprecated `@screen-md` as of v3.0.1 */
/* Deprecated `@screen-desktop` as of v3.0.1 */
/* Deprecated `@screen-lg` as of v3.0.1 */
/* Deprecated `@screen-lg-desktop` as of v3.0.1 */
/*== Grid system
//
//## Define your custom responsive grid. */
/* Number of columns in the grid. */
/* Padding between columns. Gets divided in half for the left and right. */
/* Point at which the navbar becomes uncollapsed. */
/* Point at which the navbar begins collapsing. */
/*== Container sizes
//
//## Define the maximum width of `.container` for different screen sizes. */
/* Small screen / tablet */
/* For `@screen-sm-min` and up. */
/* Medium screen / desktop */
/* For `@screen-md-min` and up. */
/* Large screen / wide desktop */
/* For `@screen-lg-min` and up. */
/*== Navbar
//
//## */
/* Basics of a navbar */
/*== Inverted navbar */
/*== Navs
//
//## */
/*== Shared nav styles */
/*== Tabs */
/*== Pills */
/*== Pagination
//
//## */
/*== Pager
//
//## */
/*== Jumbotron
//
//## */
/*== Form states and alerts
//
//## Define colors for form feedback states and, by default, alerts. */
/*== Tooltips
//
//## */
/* Tooltip max width */
/* Tooltip text color */
/* Tooltip background color */
/* Tooltip arrow width */
/* Tooltip arrow color */
/*== Popovers
//
//## */
/* Popover body background color */
/* Popover maximum width */
/* Popover border color */
/* Popover fallback border color */
/* Popover title background color */
/* Popover arrow width */
/* Popover arrow color */
/* Popover outer arrow width */
/* Popover outer arrow color */
/* Popover outer arrow fallback color */
/*== Labels
//
//## */
/* Default label background color */
/* Primary label background color */
/* Success label background color */
/* Info label background color */
/* Warning label background color */
/* Danger label background color */
/* Default label text color */
/* Default text color of a linked label */
/*== Modals
//
//## */
/* Padding applied to the modal body */
/* Padding applied to the modal title */
/* Modal title line-height */
/* Background color of modal content area */
/* Modal content border color */
/* Modal content border color **for IE8** */
/* Modal backdrop background color */
/* Modal backdrop opacity */
/* Modal header border color */
/* Modal footer border color */
/*== Alerts
//
//## Define alert colors, border radius, and padding. */
/*== Progress bars
//
//## */
/* Background color of the whole progress component */
/* Progress bar text color */
/* Variable for setting rounded corners on progress bar. */
/* Default progress bar color */
/* Success progress bar color */
/* Warning progress bar color */
/* Danger progress bar color */
/* Info progress bar color */
/*== List group
//
//## */
/* Background color on `.list-group-item` */
/* `.list-group-item` border color */
/* List group border radius */
/* Background color of single list items on hover */
/* Text color of active list items */
/* Background color of active list items */
/* Border color of active list elements */
/* Text color for content within active list items */
/* Text color of disabled list items */
/* Background color of disabled list items */
/* Text color for content within disabled list items */
/*== Panels
//
//## */
/* Border color for elements within panels */
/*== Thumbnails
//
//## */
/* Padding around the thumbnail image */
/* Thumbnail background color */
/* Thumbnail border color */
/* Thumbnail border radius */
/* Custom text color for thumbnail captions */
/* Padding around the thumbnail caption */
/*== Wells
//
//## */
/*== Badges
//
//## */
/* Linked badge text color on hover */
/* Badge text color in active nav link */
/* Badge background color in active nav link */
/*== Breadcrumbs
//
//##

@breadcrumb-padding-vertical:   8px;
@breadcrumb-padding-horizontal: 15px;
/* Breadcrumb background color */
/* Breadcrumb text color */
/* Text color of current page in the breadcrumb */
/* Textual separator for between breadcrumb elements */
/*== Carousel
//
//## */
/*== Close
//
//## */
/*== Code
//
//## */
/*== Type
//
//## */
/* Horizontal offset for forms and lists. */
/* Text muted color */
/* Abbreviations and acronyms border color */
/* Headings small color */
/* Blockquote small color */
/* Blockquote font size */
/* Blockquote border color */
/* Page header border color */
/* Width of horizontal description list titles */
/* Point at which .dl-horizontal becomes horizontal */
/* Horizontal line color. */
/* Tools */
/*    Main mixins    */
/* ICON FONT - DecathlonCube and iconfont*/
/* LOADING GIF */
/* Rate element
usage
  .star-rate(@width);
*/
/* Hide content visually, but keep them availbale for seo and screen reader */
/* FONT */
/* font-[stretch value]-[weight keyword]-[style value] */
/* LEGACY */
/**
 * ##Buttons
 * File : path/button.less TODO
 */
/**
 * ### Generic button
 * `.cta`
 *
 *     @example
 *     a.cta(href="#")|My button
 *
 */
/**
 * ### Colors
 * Color class available : `.grey` `.yellow`
 *
 *     @example
 *     a.cta(href="#")|My button
 *     a.cta.yellow(href="#")|My button
 *     a.cta.grey(href="#")|My button
 *
 */
/**
 * ### With icon
 * [See icons available](http://iconslink.com).
 *
 *     @example
 *     a.cta.cta-icon.left(href="#")|My button
 *       span.icon.icon-search
 *
 */
/**
 * ### Small size
 * Size class available : `.small`
 *
 *     @example
 *     a.cta.small(href="#")|My button
 *     a.cta.yellow.small(href="#")|My button
 *     a.cta.grey.small(href="#")|My button
 *
 */
/**
 * ### Arrow
 * Arrow class available : `.left` `.right`
 *
 *     @example
 *     a.cta.left(href="#")|My button
 *     a.cta.yellow.right(href="#")|My button
 *     a.cta.grey.right(href="#")|My button
 *
 */
/**
 * ### Others display
 * Class available : `.disabled`
 *
 *     @example
 *     a.cta.disabled(href="#")|My button
 *
 */
/*
 * I converted the SCSS mixin to LESS for the awesome coders like myself in response to a blog post on 37Signals - http://37signals.com/svn/posts/3271-easy-retina-ready-images-using-scss
 *
 * Update: 2014-08-04 - Updated a long-standing bug where retina images were shown no matter what in the first background-image property.
 *                    - Updated retina media query to be more reliable ()
 * Update: 2013-11-13 - Picked up another technique thanks to reading this post from Tyler Tate, auto-fill in the second filename for the retina image, http://tylertate.com/blog/2013/06/11/retina-images-using-media-queries-and-LESS-CSS.html
 * Update: 2013-04-16 - Have recently found a few use cases when using a retina pattern from Subtle Patterns on the <body>, this has come in handy
 * Update: 2013-04-05 - Some research in the Wordpress Core(http://core.trac.wordpress.org/ticket/22238#comment:5) was pointed out that some tests may be redundant (Thanks @kbav) so I've cleaned these up
 * Update: 2012-12-29 - Updated AGAIN to add MS IE10 declaration and fix wonky 'min--moz-' declaration which Mozilla engineers are aware of
 * Update: 2012-11-21 - Updated again based on information from an article I found, added dppx and changed opera ratio to target more devices (http://www.uifuel.com/hd-retina-display-media-queries/)
 * Update: 2012-11-17 - Updated based on Wordpress Core to target even more devices! Thanks @Wordpress <3 (http://core.trac.wordpress.org/changeset/22629)
 */
/**
 * ##Titles
 * File : path/texts.less
 */
/**
 * ### Title header
 * `.title-header`
 *
 *     @example
 *     h1.title-header|My title
 *
 */
/**
 * ### Title header variant
 * `.title-header-variant`
 *
 *     @example
 *     h1.title-header-variant|My title variant
 *
 */
/**
 * ### Title product
 * `.title-product`
 *
 *     @example
 *     h1.title-product|My title product
 *
 */
/**
 * ### Subtitle
 * `.title-subtitle`
 *
 *     @example
 *     h1.title-subtitle|My subtitle
 *
 */
/**
 * ### Mixin titlePage
 * `.titlePage(@size, @color, @spanColor)`
 *
 *     @example
 *     a.cta-link.upper(href="#")|My link
 *
 * Example :
 * `.titlePage(1em, @white, @black)`
 *
 */
@-webkit-keyframes zoomicon {
  from {
    opacity: 0;
    -webkit-transform: scale(0.1, 0.1);
    -moz-transform: scale(0.1, 0.1);
    -ms-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}
@keyframes zoomicon {
  from {
    opacity: 0;
    -webkit-transform: scale(0.1, 0.1);
    -moz-transform: scale(0.1, 0.1);
    -ms-transform: scale(0.1, 0.1);
    transform: scale(0.1, 0.1);
  }
  to {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
}
@-webkit-keyframes vibe {
  from {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  to {
    opacity: 0;
    -webkit-transform: scale(1.3, 1.3);
    -moz-transform: scale(1.3, 1.3);
    -ms-transform: scale(1.3, 1.3);
    transform: scale(1.3, 1.3);
  }
}
@keyframes vibe {
  from {
    opacity: 1;
    -webkit-transform: scale(1, 1);
    -moz-transform: scale(1, 1);
    -ms-transform: scale(1, 1);
    transform: scale(1, 1);
  }
  to {
    opacity: 0;
    -webkit-transform: scale(1.3, 1.3);
    -moz-transform: scale(1.3, 1.3);
    -ms-transform: scale(1.3, 1.3);
    transform: scale(1.3, 1.3);
  }
}
.search-result {
  position: relative;
  background-color: #fff;
  border-top: 0.1rem solid #edeff1;
  text-transform: uppercase;
  overflow: auto;
  padding: 1rem;
  z-index: 1;
  text-align: left;
}
.search-result :global(.highlight) {
  display: inline;
  color: #0082c3;
  font-weight: bold;
  font-style: italic;
}
.list {
  display: flex;
  margin: 0;
  padding: 0;
}
.list:not(:first-child) {
  border-top: 0.1rem solid #edeff1;
  padding-top: 1rem;
}
.list ul {
  margin: 0;
  padding: 0;
}
.list h3 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.trends-list,
.pages-list {
  flex-direction: column;
  flex-grow: 1;
  min-width: 30%;
}
.trends-list li:not(:first-child),
.pages-list li:not(:first-child) {
  border-top: 0.1rem solid #edeff1;
}
.trends-list a,
.pages-list a {
  font-weight: bold;
  display: block;
  font-size: 1.6rem;
  color: #afb1b3;
  padding: 1rem 3rem 1rem 0.5rem;
  transition: all 250ms ease;
}
.trends-list a:hover,
.pages-list a:hover,
.trends-list a:focus,
.pages-list a:focus {
  color: #7d7e80;
  background-color: #edeff1;
}
.products-list {
  flex-direction: row;
  flex-wrap: wrap;
  flex-grow: 1;
  position: relative;
}
.products-list::after {
  content: '';
  height: 0.1rem;
  width: 100%;
  margin-top: -0.1rem;
  background-color: #fff;
}
.products-list li {
  padding: 1rem;
  border-right: 0.1rem solid #edeff1;
  border-bottom: 0.1rem solid #edeff1;
  flex-grow: 1;
}
@media (max-width: 1079px) {
  .products-list li {
    width: 50%;
  }
  .products-list li:nth-child(n + 2) {
    flex-grow: 0;
  }
  .products-list li:nth-child(-n + 2):last-child,
  .products-list li:nth-child(2n) {
    border-right: none;
  }
}
@media (min-width: 1080px) and (max-width: 1599px) {
  .products-list li {
    width: 33.33333%;
  }
  .products-list li:nth-child(n + 3) {
    flex-grow: 0;
  }
  .products-list li:nth-child(-n + 3):last-child,
  .products-list li:nth-child(3n) {
    border-right: none;
  }
}
@media (min-width: 1600px) {
  .products-list li {
    width: 25%;
  }
  .products-list li:nth-child(n + 4) {
    flex-grow: 0;
  }
  .products-list li:nth-child(-n + 4):last-child,
  .products-list li:nth-child(4n) {
    border-right: none;
  }
}
.products-list li a:hover,
.products-list li a:focus {
  color: #0082c3;
}
.products-list li div {
  width: 100%;
  height: 7rem;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
}
.products-list li span {
  display: block;
  text-align: center;
  width: 100%;
  font-style: italic;
  padding: 1.5rem;
  font-size: 1.3rem;
  line-height: 1.2;
}
@media (min-width: 801px) {
  .search-result {
    padding: 1rem;
    position: absolute;
    left: 1rem;
    right: 1rem;
    top: 100%;
    min-width: 40rem;
    box-shadow: 0 0.2rem 0.75rem rgba(0, 0, 0, 0.25);
  }
}
@media (min-width: 1180px) {
  .search-result {
    display: flex;
    flex-direction: row;
  }
  .list:not(:first-child) {
    border-top: none;
    border-left: 0.1rem solid #edeff1;
    padding-left: 1rem;
    margin-left: 1rem;
    padding-top: 0;
  }
}
</style>



<svelte:window on:click={close} on:keydown={close}/>

<form
  method="get"
  role="search"
  on:submit={submit}
  action={searchlocaleurl}
  aria-expanded={(searchResults !== null)}
  aria-controls="search-result"
>
  <div class="input-wrap HeaderMobileSearch-searchInput">
    <input
      id="search-autocomplete"
      autocomplete="off"
      type="search"
      name="Ntt"
      bind:this={input}
      on:input={search}
      on:focus={ () => showResultPanel = true }
      placeholder={i18n('search.placeholder')}
      aria-label={i18n('search.placeholder')}
    >
  </div>

  <div class="button-wrap HeaderMobileSearch-btn">
    <button id="search-button" type="submit" aria-label={i18n('search.label')}>
      <span class="icon icon-search" />
    </button>
  </div>
</form>

{#if showResultPanel && (showResults || showTrends) }
  <div
    class="search-result"
    id="search-result"
    role="menu"
    transition:fly={{ y: -10, duration: 200 }}
    data-tnr-search-suggestion-layer
  >

    {#if showTrends }
      <div class="list trends-list">
      <h3 class="title--4th">{i18n('search.trends.title')}</h3>
        <ul>
          {#each trends as trend}
            <li>
              <a role="menuitem" href={trend.link} title={trend.name}>
                {trend.displayName}
              </a>
            </li>
          {/each}
        </ul>
      </div>
    {/if}

    {#if showResults}
      {#if searchResults.pages && searchResults.pages.length}
        <ul class="list pages-list">
          {#each searchResults.pages as page}
            <li>
              <a role="menuitem" href={page.url} title={page.name} data-tnr-search-suggestion-categorie>
                {@html highlightWords(searchTerm, page.name)}
              </a>
            </li>
          {/each}
        </ul>
      {/if}

      {#if searchResults.products && searchResults.products.length}
        <ul class="list products-list">
          {#each searchResults.products as product}
            <li>
              <a
                role="menuitem"
                href={product.url}
                title={product.name}
                data-id={product.modelReferenceCode}
                data-price={product.price}
                data-tnr-search-suggestion-product>
                <div style={`background-image: url(${product.picture})`} data-tnr-search-suggestion-product-image />
                <span data-tnr-search-suggestion-product-name>
                  {@html highlightWords(searchTerm, product.name)}
                </span>
              </a>
            </li>
          {/each}
        </ul>
      {/if}
    {/if}

  </div>
{/if}



// WEBPACK FOOTER //
// ./src/commons/header/search/Search.svelte